import React, { useState } from "react";
import InputField from "../../../../components/InputField";
import { getUpiPatternForQR } from "../../../../helper/functions";

interface Props {
  setValue: (value: string) => void;
  prefilledValue?: {
    UPIId: string;
    name: string;
  };
  errors?: {
    upiIdError: string;
    nameError: string;
  };
}

const GenerateUPIQr: React.FC<Props> = ({
  setValue,
  prefilledValue,
  errors,
}) => {
  const [state, setState] = useState(
    prefilledValue || {
      UPIId: "",
      name: "",
    }
  );

  return (
    <>
      <InputField
        name="name"
        value={state.name}
        onChange={(e) => {
          setState({ ...state, name: e.target.value });
          setValue(getUpiPatternForQR(state.UPIId, e.target.value));
        }}
        type="text"
        label="Enter name"
        placeholder="Enter name of the payee..."
        error={errors?.nameError}
      />
      <InputField
        name="upi"
        value={state.UPIId}
        onChange={(e) => {
          setState({ ...state, UPIId: e.target.value });
          setValue(getUpiPatternForQR(e.target.value, state.name));
        }}
        type="text"
        label="Enter UPI ID"
        placeholder="Enter your UPI ID here..."
        error={errors?.upiIdError}
      />
    </>
  );
};

export default GenerateUPIQr;
